module.exports = __webpack_public_path__ + "media/images/logos/nvidia_logo-4363470bb96910bc29db9686d63c54f4.png";